module.exports = __webpack_public_path__ + "img/case2.36fb8ba8.png";